<template>
  <div :class="{ 'ful-section': !bare }" v-if="orderInfo">
    <div :class="{ 'ful-section-heading': bare, 'ful-inner-section-heading': !bare }" v-if="showHeading">
      <svg class="ful-section-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
      <h2 class="ful-section-title">收件人信息</h2>
      <button v-if="showModify" class="ful-btn-edit" @click="$emit('modifyAddress')" style="margin-left:auto">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
        修改
      </button>
    </div>
    <div :class="{ 'ful-info-grid': bare }" v-if="orderInfo">
      <div><span class="ful-info-label">收件人：</span><span class="ful-info-value">{{ orderInfo.recipientName }}</span></div>
      <div><span class="ful-info-label">联系方式：</span><span class="ful-info-value">{{ orderInfo.recipientPhone }}</span></div>
      <div style="grid-column:1/-1"><span class="ful-info-label">收货地址：</span><span class="ful-info-value">{{ orderInfo.recipientAddress }}</span></div>
      <div v-if="orderInfo.zipCode"><span class="ful-info-label">邮编：</span><span class="ful-info-value">{{ orderInfo.zipCode }}</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecipientInfo',
  props: {
    orderInfo: { type: Object, required: true },
    showModify: { type: Boolean, default: false },
    bare: { type: Boolean, default: false },
    showHeading: { type: Boolean, default: true }
  }
}
</script>
